/**
 * Wrapper component to handle form input fields
 * that use Formik, Reactstrap and react-input-mask.
 */
import { useField } from "formik";
import React from "react";
import InputMask from "react-input-mask";
import { FormFeedback, FormGroup, Input, Label } from "reactstrap";

const FormInputMask = ({ label, floating, bsSize, mask, ...other }) => {
  const [field, meta] = useField(other);
  const invalid = Boolean(meta.touched && meta.error);
  return (
    <FormGroup
      floating={floating}
      className={other.type === "hidden" ? "visually-hidden" : undefined}
    >
      {!floating && label && (
        <Label size={bsSize} for={other.id}>
          {label}
        </Label>
      )}
      <InputMask mask={mask} {...field} {...other} value={field.value || ""}>
        {(inputProps) => (
          <Input {...inputProps} bsSize={bsSize} invalid={invalid} />
        )}
      </InputMask>
      {floating && label && <Label for={other.id}>{label}</Label>}
      {invalid ? <FormFeedback>{meta.error}</FormFeedback> : null}
    </FormGroup>
  );
};

export default FormInputMask;
